import React from 'react';
import { useForm } from 'react-final-form';

import { useSelector } from 'hooks/useSelector';
import { getSignInLoading } from 'modules/auth/selectors';
import { Input } from 'ui/base';
import FormField from 'ui/form/FormField';

import { required } from '../../../../../common/forms/FormValidationHelper';

const Password = () => {
  const { submit } = useForm();
  const isSigningIn = useSelector(getSignInLoading);

  return (
    <FormField name="password" labelId="password" required validate={required}>
      {input => <Input.Password {...input} data-cy="password" onPressEnter={submit} disabled={isSigningIn} />}
    </FormField>
  );
};

export default Password;
